import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/app/App';
import { ROUTES } from './src/features/routing/constants';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found.');
}

const useSecondaryBackground = ([ROUTES.Welcome, ROUTES.Login] as string[]).includes(
  location.pathname
);
if (useSecondaryBackground) {
  document.documentElement.setAttribute('data-bg-variant', 'secondary');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
